/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { CollapseSection } from '@/components/ui'

/** Beyond this many, the list folds away so the editor stays near the top. */
const INLINE_LIMIT = 10

export interface SelectedName {
  key: string
  label: string
  title?: string
}

interface Props {
  items: SelectedName[]
  /** Plural noun for the fold-away title, e.g. "users" or "companies". */
  noun: string
  'data-testid'?: string
}

const badgeList = (items: SelectedName[], testId: string) => (
  <ul className="flex flex-wrap gap-1" data-testid={testId}>
    {items.map((item) => (
      <li key={item.key} className="badge badge-ghost badge-sm" title={item.title}>
        {item.label}
      </li>
    ))}
  </ul>
)

/** Who or what a bulk change will apply to. */
export const SelectedNamesSummary: React.FC<Props> = ({ items, noun, 'data-testid': testId = 'selected-names' }) =>
  items.length > INLINE_LIMIT ? (
    <CollapseSection
      title={
        <span className="text-sm">
          Show the {items.length} selected {noun}
        </span>
      }
    >
      {badgeList(items, testId)}
    </CollapseSection>
  ) : (
    badgeList(items, testId)
  )

export default SelectedNamesSummary
